import { useEffect, useState } from "react";
import '../../Style/product/fill-form.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CusIconLabel from "../../Components/custom-icon-label/Cus_Icon_Label.js";
import CustomButton from "../../Components/custom-button/CustomButton.js";
import CustomCheckBoxWithCustomWidget from "../../Components/custom-checkbox/CustomCheckBoxWithCustomWidget.js";
import { calculateAge, isNullOrEmpty, openInNewTab, ValidatePhone } from "../../Services/service.js";
import { t } from "i18next";
import { nextStep, validateValidPromotionCode } from "../../Services/api-service.js";
import { warning } from "../../Components/custom-toast/CustomToast.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB";
import dayjs from "dayjs";
import { vi } from 'date-fns/locale';


registerLocale("en-GB", enGB);
function FillFormSection({objectDto, setStatus, setObjectDto, setIsLoading, confirm, setConfirm}){
    const handleChange = (e) => {
        const { name, value } = e.target;
        setObjectDto(prev=>({ ...prev, [name]: value }));
    }
    const handleButtonClick = () => {
        if(validateData()){
            var db = {...objectDto, age: calculateAge(objectDto.dob), step: 0};
            setIsLoading(true);
            // nextStep(db, setObjectDto, setIsLoading);
            if(isNullOrEmpty(db.promotionCode)){
                db = {...db, discount: 0, promotionCode: null};
                nextStep(db, setObjectDto, setIsLoading);
            }else{
                validateValidPromotionCode(db, setObjectDto, setIsLoading);
            }
            setStatus(true);
        }
    }
    function handleNavigate(url){
        openInNewTab(url);
    }
    const validateData = () => {
        if(isNullOrEmpty(objectDto.fullName)) {
            warning(t("nullfullname"));
            return false;
        }
        if(isNullOrEmpty(objectDto.dob)) {
            warning(t("nullbirth"));
            return false;
        }
        if(isNullOrEmpty(objectDto.gender)){
            warning(t("nullgender"));
            return false;
        }
        if(isNullOrEmpty(objectDto.phoneNumber)){
            warning(t("nullphone"));
            return false;
        }
        if(isNullOrEmpty(objectDto.email)){
            warning(t("nullemail"));
            return false;
        }
        if(!ValidatePhone(objectDto.phoneNumber)){
            warning(t("wrongformatphone"));
            return false;
        }
        if(calculateAge(objectDto.dob) < 18 || calculateAge(objectDto.dob) > 60) {
            warning(t("notenoughage"));
            return false;
        }
        return true;
    }
    const now = new Date();
    const minDate = new Date("1900-01-01T00:00:00");
    const handleChangeDate = (newValue) => {
        if(isNullOrEmpty(newValue)) return setObjectDto(prev => ({...prev, dob: null}));
        return setObjectDto(prev => ({...prev, dob: dayjs(newValue).format("YYYY-MM-DD")}));
    }
    
    return (
        <section className="fill-form">
            <div className="container-card-fill-form">
                <div className="home-fill-form-wrapper">
                    <div className="fill-form-form">
                        <label className="fill-form-label-title-form home-content-product">{t("product")}</label>
                        <div className="title-fill-form-wrap">
                            <h2 className="title-font-fill-form home-title-product">Phú Bảo An Gia 2.0</h2>
                        </div>
                        <p className="home-desc-title-product">Bảo vệ toàn diện trước 10 bệnh hiểm nghèo thường gặp</p>
                        <br/>
                        <span>
                            <CusIconLabel Icon={CheckCircleIcon} text={"Giảm gánh nặng tài chính trước các rủi ro bệnh hiểm nghèo."} />
                            <CusIconLabel Icon={CheckCircleIcon} text={"Gói bảo hiểm đa dạng với mức chi phí hợp lý"} />
                            <CusIconLabel Icon={CheckCircleIcon} text={"Tham gia trực tuyến đơn giản, không cần khám sức khỏe."} />
                        </span>
                    </div>
                    <div className="fill-form-fill">
                        <div className="border-fill-form-fill">
                            <div className="title-contact-wrap">
                                <h2 className="title-font-form-fill product-title-form">{t("productfilldesc")}</h2>
                            </div>
                            <div className="form-input-fill-form">
                                <label className="label-fill-form product-label-form">{t("fullname")}</label>
                                <input className='ipt-box-wlabel-product-fill' type="text" name="fullName" value={objectDto.fullName} onChange={handleChange} placeholder={t("pleasefill")}/>
                            </div>
                            <div className="form-input-fill-form">
                                <label className="label-fill-form product-label-form">{t("dob")}</label>
                                <DatePicker
                                    selected={objectDto.dob}
                                    onChange={handleChangeDate}
                                    dateFormat="dd/MM/yyyy"
                                    locale={vi}
                                    className="ipt-box-wlabel-product-fill"
                                    style={{width: "100%"}}
                                    minDate={minDate}
                                    maxDate={now}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                            </div>
                            <div className="form-input-fill-form">
                                <label className="label-fill-form product-label-form">{t("gender")}</label>
                                <select className='ipt-box-wlabel-product-fill' name="gender" value={objectDto.gender}  onChange={handleChange}>
                                    <option className='ipt-box-wlabel-product-fill' value={0}>{t("gendermale")}</option>
                                    <option className='ipt-box-wlabel-product-fill' value={1}>{t("genderfemale")}</option>
                                </select>
                            </div>
                            <div className="form-input-fill-form">
                                <label className="label-fill-form product-label-form">{t("phonenumber")}</label>
                                <input className='ipt-box-wlabel-product-fill' type="text" name="phoneNumber" maxLength={10} value={objectDto.phoneNumber} onChange={handleChange} placeholder={t("pleasefill")}/>
                            </div>
                            <div className="form-input-fill-form">
                                <label className="label-fill-form product-label-form">{t("email")}</label>
                                <input className='ipt-box-wlabel-product-fill' type="text" name="email" value={objectDto.email} onChange={handleChange} placeholder={t("pleasefill")}/>
                            </div>
                            <div className="form-input-fill-form">
                                <label className="label-fill-form product-label-form">{t("promotionCode")}</label>
                                <input className='ipt-box-wlabel-product-fill' type="text" name="promotionCode" value={objectDto.promotionCode} onChange={handleChange} placeholder={t("pleasefill")} maxLength={10}/>
                            </div>
                        </div>
                        <CustomCheckBoxWithCustomWidget value={confirm} setValue={setConfirm} 
                            childText={
                                <label onClick={() => {setConfirm(!confirm)}} className="checkbox-label" style={{fontWeight: 400}}>{t("ireadandagreewith")}{" "} 
                                    <span style={{ cursor: 'pointer', textDecoration: "underline", fontWeight: 600 }} onClick={() => handleNavigate("/rule/3. Cam kết bảo mật.pdf")}>{t("securitypolicy")}</span> 
                                    {", "} 
                                    <span style={{ cursor: 'pointer', textDecoration: "underline", fontWeight: 600 }} onClick={() => handleNavigate("/rule/4. Chính sách xử lý dữ liệu cá nhân.pdf")}>{t("personaldataprocessingpolicy")}</span>
                                    {", "} 
                                    <span style={{ cursor: 'pointer', textDecoration: "underline", fontWeight: 600 }} onClick={() => handleNavigate("/rule/5. Chính sách cung cấp sản phẩm bảo hiểm trực tuyến của Phú Hưng Life.pdf")}>{t("concurrentPHL")}</span>
                                    {". "} {t("understandfollowpolicy")}
                                </label>}
                            />
                        <div className="form-input-fill-form cus-button">
                            <CustomButton title={t("viewfeepolicy")} disable={(!confirm)}  onClick={handleButtonClick}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>    
    );
}
export default FillFormSection;